async function fetchAsync(method, URL, body = null, token, headers) {

  console.log('FETCH', method, URL)

  const requestHeaders = Object.assign({}, {
    "Accept": "application/json",
    "Content-Type": "application/json",
    "x-access-token": token
  }, headers)

  const request = {
    method,
    mode: 'cors',
    headers: requestHeaders,
    body
  }

  console.log("HTTP Client", request)

  if (headers) request.headers = request.headers

  try {
    var response = await fetch(URL, request);
    if (response.ok) {
      const json = await response.json();
      return json
    }
    throw response
  } catch (error) {
    if (error instanceof Error) { throw { error }}
    const json = await error.json()
    throw {
      success: false,
      message: json.message
    }
  }
}


export const HTTPClient = (domain, securityCtx) => {
  return {

    GET: (URL) => {
      const token = securityCtx ? securityCtx.token() : null;
      return fetchAsync('GET', domain + URL, undefined, token);
    },

    POST: (URL, body, headers) => {
      const token = securityCtx ? securityCtx.token() : null;
      return fetchAsync('POST', domain + URL, body, token, headers);
    },

    PUT: (URL, body) => {
      const token = securityCtx ? securityCtx.token() : null;
      return fetchAsync('PUT', domain + URL, body, token);
    },

    PATCH: (URL, body) => {
      const token = securityCtx ? securityCtx.token() : null;
      return fetchAsync('PATCH', domain + URL, body, token);
    },

    DELETE: (URL) => {
      const token = securityCtx ? securityCtx.token() : null;
      return fetchAsync('DELETE', domain + URL, undefined, token);
    }
  }
}